import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { ChevronDown, Search } from "lucide-react";

export default function MultiSelectFilter({ label, options, selected, onChange, searchable = false, testid }) {
  const [q, setQ] = useState("");
  const toggle = (o) => onChange(selected.includes(o) ? selected.filter((x) => x !== o) : [...selected, o]);
  const shown = options.filter((o) => !q || o.toLowerCase().includes(q.toLowerCase()));
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid={testid} type="button"
          className={`inline-flex items-center gap-2 border border-black px-3 py-2 text-sm bg-white ${selected.length ? "bg-royal-700/10" : ""}`}>
          {label}{selected.length > 0 && <span className="font-mono-tight text-xs bg-black text-white rounded-full px-1.5">{selected.length}</span>}
          <ChevronDown size={14} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-64 p-2" data-testid={`${testid}-menu`}>
        {searchable && (
          <div className="relative mb-2">
            <Search size={12} className="absolute left-2 top-1/2 -translate-y-1/2 text-neutral-400" />
            <input data-testid={`${testid}-search`} value={q} onChange={(e) => setQ(e.target.value)} placeholder={`Search ${label.toLowerCase()}…`}
              className="w-full border border-black/15 rounded-md pl-7 pr-2 py-1.5 text-sm" />
          </div>
        )}
        <div className="max-h-60 overflow-auto">
          {shown.map((o) => (
            <label key={o} className="flex items-center gap-2 px-2 py-1.5 text-sm rounded hover:bg-neutral-100 cursor-pointer">
              <input type="checkbox" data-testid={`${testid}-opt-${o}`} checked={selected.includes(o)} onChange={() => toggle(o)} />
              <span className="truncate">{o}</span>
            </label>
          ))}
          {shown.length === 0 && <div className="text-xs text-neutral-500 px-2 py-2">No options.</div>}
        </div>
        {selected.length > 0 && (
          <button type="button" data-testid={`${testid}-clear`} onClick={() => onChange([])} className="mt-2 text-xs underline underline-offset-4 px-2">Clear</button>
        )}
      </PopoverContent>
    </Popover>
  );
}
